import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import Prescription from '../../components/prescription/Prescription';
import {
  loadPrescript,
  setOriginalID,
  removePrescription,
  initRemoveRes,
  initializePrescriptions,
} from '../../modules/prescription/prescription';
import { withRouter } from 'react-router-dom';
import DeleteModal from '../../components/common/ConfirmModal';
import {
  initializePrescription,
  modifyPrescription,
} from '../../modules/prescription/addPrescription';
import AskRemoveModal from '../../components/common/AskRemoveModal';
import Record from '../../components/record/Record';
import RecordBoard from '../../components/record/RecordBoard';
import {
  loadRecordDate,
  loadRecord,
  selectDate,
  selectRecordFc,
  loadRecordHistory,
  initRecord,
} from '../../modules/record/record';

import {
  loadAllFC,
} from '../../modules/prescription/addPrescription';
import HistoryModal from '../../components/record/HistoryModal';
import RegistContainer from './RegistContainer';
import { IoIosClose } from 'react-icons/io';

const ModalCloseBlock = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;

  svg {
    cursor: pointer;
    font-size: 2.5rem;
    color: #666;
    
    &:hover {
      color: #333;
    }
  }
`;

const PrescriptionContainer = ({ history }) => {
  const dispatch = useDispatch();
  const [removeModal, setRemoveModal] = useState(false);
  const [recordModal, setRecordModal] = useState(false);
  const [recordDetailModal, setRecordDetailModal] = useState(false);
  const [prescriptionModal, setPrescriptionModal] = useState(false);
  const {
    loading,
    club,
    socketKey,
    prescription,
    prescriptions,
    registResult,
    dateLoading,
    recordLoading,
    historyLoading,
    fcList,
    target,
    recordDates,
    record,
    selectedDate,
    fcHistory,
    selectedFc,
  } = useSelector(
    
    ({ loading, club, socket, prescription, addPrescription, record }) => ({
      club: club.defaultClub,
      //      loading: loading['search/SEARCH_MEMBER'],
      socketKey: socket.socketKey,
      prescription: prescription,
      prescriptions: prescription.prescriptions,
      loading: loading['prescription/LOAD_PRESCRIPTION'],
      dateLoading: loading['record/LOAD_RECORD_DATE'],
      recordLoading: loading['record/LOAD_RECORD'],
      historyLoading: loading['record/LOAD_FC_HISTORY'],
      registResult: addPrescription.registResult,
      target: prescription.target,
      recordDates: record.recordDates,
      record: record.record,
      selectedDate: record.selectedDate,
      fcHistory: record.history,
      selectedFc: record.selectedFc,
      fcList: addPrescription.fcList,
    }),
  );

  const onCloseRemoveModal = () => {
    setRemoveModal(false);
  };

  const onOpenRemoveModal = (item) => {
    setRemoveModal(true);
    dispatch(setOriginalID(item.fcProgramID));
  };

  const onOpenRecordModal = (fc) => {
    dispatch(selectRecordFc(fc));
    dispatch(
      loadRecordHistory({
        socketKey,
        targetID: target.playerID,
        fcindex: fc.fcindex,
      }),
    );
    setRecordModal(true);
  };

  const onCloseRecordModal = () => {
    setRecordModal(false);
  };

  const onOpenRecordDetailModal = () => {
    setRecordDetailModal(true);
  };

  const onCloseRecordDetailModal = () => {
    setRecordDetailModal(false);
  };

  const onClick = () => {
    if (!prescription.target) {
      alert('회원을 선택해 주세요');
      return false;
    }
    setPrescriptionModal(true);
    dispatch(initializePrescription());
  };

  const onClosePrescriptionModal = () => {
    setPrescriptionModal(false);
  };

  const onConfirm = async () => {
    onCloseRemoveModal();
    dispatch(
      removePrescription({
        socketKey,
        fcProgramID: prescription.originalID,
        targetID: prescription.target.playerID,
      }),
    );
    dispatch(
      loadPrescript({
        socketKey,
        targetID: prescription.target.playerID,
      }),
    );
  };

  const onClickPrescription = (prescription) => {
    const floatWeightPrescription = {
      ...prescription,
      fcGroupDetail: prescription.fcGroupDetail.map((item) => ({
        ...item,
        goal: {
          ...item.goal,
          set: item.goal.set.map((oneSet) => ({
            ...oneSet,
            weight: oneSet.weight / 10,
          })),
        },
      })),
    };
    dispatch(modifyPrescription(floatWeightPrescription));
    setPrescriptionModal(true);
  };

  useEffect(() => {
    if (prescription.target) {
      dispatch(
        loadPrescript({
          socketKey,
          targetID: prescription.target.playerID,
        }),
      );
    } else {
      dispatch(initializePrescriptions());
    }
  }, [
    dispatch,
    prescription.target,
    socketKey,
    prescription.removeRes,
    registResult,
  ]);

  useEffect(() => {
    if (prescription.removeRes === 1) {
      alert('삭제되었습니다.');
      dispatch(initRemoveRes());
    }
  }, [dispatch, prescription.removeRes]);

  useEffect(() => {
    if (target) {
      dispatch(
        loadRecordDate({
          socketKey,
          targetID: target.playerID,
        }),
      );
    }
  }, [target, dispatch, socketKey]);

  useEffect(() => {
    if (selectedDate && target) {
      dispatch(
        loadRecord({
          socketKey,
          targetID: target.playerID,
          date: parseInt(selectedDate),
        }),
      );
    } else {
      dispatch(initRecord());
    }
  }, [selectedDate, target]);

  useEffect(() => {
    if (recordDates && recordDates.date) {
      dispatch(selectDate(recordDates.date.sort((a, b) => b - a)[0]));
    }
  }, [recordDates]);

  useEffect(() => {
    if (club) {
      dispatch(loadAllFC({ socketKey, clubID: club.clubID }));
    }
  }, [dispatch, socketKey, club]);

  const onSelectDate = (date) => {
    dispatch(selectDate(date));
  };

  const onChangeDate = (flag) => {
    const { date } = recordDates;
    const currentIndex = date.findIndex((d) => d === selectedDate);
    let newDate;
    if (flag === 'next') {
      if (currentIndex !== 0) newDate = date[currentIndex - 1];
      else newDate = date[0];
    } else if (flag === 'previous')
      if (currentIndex !== date.length - 1) {
        newDate = date[currentIndex + 1];
      } else newDate = date[currentIndex];

    dispatch(selectDate(newDate));
    dispatch(
      loadRecord({
        socketKey,
        targetID: target.playerID,
        date: parseInt(newDate),
      }),
    );
  };
  const filterFakeRecord = () => {
    if (record && record.fcGroup) {
      const { fcGroupDetail } = record.fcGroup;

      const realData = fcGroupDetail.filter((fc) => {
        if ([3, 4].includes(fc.fctype))
          return (
            fc.complete.RM + fc.complete.value + fc.complete.set.length !== 0
          );
        else
          return (
            fc.complete.distance + fc.complete.time + fc.complete.calorie !== 0
          );
      });

      record.fcGroup.fcGroupDetail = realData;
    }
    return record;
  };
  const filterFakeHistory = () => {
    if (fcHistory && fcHistory.length > 0) {
      const realData = fcHistory.filter((item) => {
        return (
          item.complete.RM + item.complete.value + item.complete.set.length !==
          0
        );
      });

      return realData;
    }
    return fcHistory;
  };

  const findRecordFreeweightType = (fcindex)=>{
    for (let i = 0; i < fcList.length; i++) {
        if(fcList[i].fcindex == fcindex)
        {
            return fcList[i].freeweightType
        }
    }

    return 0;
  }
  return (
    <>
        <RecordBoard
            recordDates={recordDates}
            record={filterFakeRecord()}
            target={target}
            onClick={onOpenRecordDetailModal}
        />
      <Prescription
        prescriptions={prescriptions && club && club.clubID && prescriptions.filter(item => {return item.clubID === club.clubID})}
        onOpenModal={onOpenRemoveModal}
        loading={loading}
        onClick={onClick}
        onClickPrescription={onClickPrescription}
      />
      <DeleteModal
          isDelete
          text={`처방을 삭제하시겠습니까?\n삭제한 처방은 복구할 수 없습니다.`}
          onClick={() => {
            onConfirm();
            onCloseRemoveModal();
          }}
          setModal={() => {onCloseRemoveModal()}}
          confirmText = "삭제"
          onModal={removeModal}
      />
      <HistoryModal
        onClose={onCloseRecordModal}
        visible={recordModal}
        fcHistory={fcHistory}
        selectedFc={selectedFc}
        findRecordFreeweightType={findRecordFreeweightType}
        loading={historyLoading}
      />
      {recordDetailModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            maxWidth: '1200px',
            maxHeight: '90vh',
            width: '100%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <button
              onClick={onCloseRecordDetailModal}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: '#f5f5f5',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                cursor: 'pointer',
                fontSize: '18px',
                zIndex: 1001
              }}
            >
              ×
            </button>
            <Record
              recordDates={recordDates}
              record={filterFakeRecord()}
              onSelectDate={onSelectDate}
              onOpenModal={onOpenRecordModal}
              dateLoading={dateLoading}
              recordLoading={recordLoading}
              selectedDate={selectedDate}
              onChangeDate={onChangeDate}
              target={target}
              findRecordFreeweightType={findRecordFreeweightType}
            />
          </div>
        </div>
      )}
      {prescriptionModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            maxWidth: '1400px',
            maxHeight: '90vh',
            width: '100%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <ModalCloseBlock>
              <IoIosClose onClick={onClosePrescriptionModal} />
            </ModalCloseBlock>
            <RegistContainer history={history} onClose={onClosePrescriptionModal} />
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(PrescriptionContainer);
